export const CheckAgeCategory = (ageCategory) =>{
    var returnValue = "";
    switch (ageCategory) {
        case "all":
            returnValue = ("");
            break;
        case "3-5":
            returnValue = ("AND typicalAgeRange:[* TO 5]");
            break;
        case "6-8":
            returnValue = ("AND typicalAgeRange:[6 TO 8]");
            break;
        case "9-11":
            returnValue = ("AND typicalAgeRange:[9 TO 11]");
            break;
        case "12-15":
            returnValue = ("AND typicalAgeRange:[12 TO 15]");
            break;
        case "16-17":
            returnValue = ("AND typicalAgeRange:[16 TO 17]");
            break;
        case "18+":
            returnValue = ("AND typicalAgeRange:[18 TO 54]");
            break;
        case "55+":
            returnValue = ("AND typicalAgeRange:[55 TO *]");
            break;
        default:
            break;
    }

    return returnValue;
}

export const CheckActivityType = (activityType) =>{
    const base = '(terms.label:"Actie en avontuur" OR terms.label:"Moderne dans" OR terms.label:"Volksdans en werelddans" OR terms.label:"Fitness, gymnastiek, dans en vechtsport" OR terms.label:"Dance" OR terms.label:"Circus" OR terms.label:"Stijl en salondansen" OR terms.label:"Omnisport en andere" OR terms.label:"Ballet en klassieke dans" OR terms.label:"Atletiek, wandelen en fietsen" OR terms.label:"Zwemmen en watersport" OR terms.label:"Outdoor en adventure" OR terms.label:"Bal en racketsport")';
    var returnValue = "";

    switch (activityType) {
        case "all":
            returnValue = ("");
            break;
        case "beurs":
            returnValue = (
                `AND (${base} AND terms.label:"Beurs")`
            );
            break;
        case "sportkamp":
            returnValue = (`AND terms.label:"Kamp of vakantie" AND ${base}'`);  
            break;
        case "sportactiviteit":
            returnValue = ('AND terms.label:"Sportactiviteit"');
            break;
        case "fiets_wandel":
            returnValue = ('AND terms.label:"Fiets- of wandelroute"');
            break;
        case "lezing_congres":
            returnValue = (
                `AND (${base} AND terms.label:"Lezing of Congres")`
            );
            break;
        case "lessen_cursus_workshop":
            returnValue = (
                `AND (${base} AND terms.label:"Cursus of Workshop")`
            );
            break;
        default:
            break;
    }

    return returnValue;
}